// Local API: REACT_APP_API_HOST=http://localhost:9292/api/v1/proposals_public npm start
const HOST = process.env.REACT_APP_API_HOST || "https://app.topbroker.lt/api/v1/proposals_public";

export { HOST };
